import Modal from "./Modal";



const AskDrivePulleySelectionModal = ({ visible, onConfirm, onCancel, }) => {

    return (
        <Modal visible={visible} title="Warning" onConfirm={onConfirm} onCancel={onCancel} >
            <div>
                <p>드라이브 풀리를 먼저 결정하세요. 컨베이어 편집창으로 이동하시겠습니까?</p>
            </div>
        </Modal>
    );
};

export default AskDrivePulleySelectionModal;